module.exports = __webpack_public_path__ + "img/glacier-point-2.0b6f852f.jpg";